import React, { FC, ReactElement } from 'react';
import { Tab, TabItem, TabsCont } from './SectionTabs.styles';
import Tooltip from '../../HOC/Tooltip/Tooltip';

interface ISectionTabs {
  activeTab: string;
  tabs: { name: string; tooltip?: string | ReactElement; value: string }[];
  setTab: (tabName: string) => void;
}

const SectionTabs: FC<ISectionTabs> = ({ activeTab, tabs, setTab }) => (
  <TabsCont aria-label="tabs" id="TabsCont" role="tablist">
    {tabs.map(({ name, tooltip, value }) => {
      const isActive = activeTab === value;

      const tab = tooltip ? (
        <Tooltip
          tooltipDesc={tooltip}
          position="top"
          positionX="-24px"
          arrowPositionX="80px"
          positionY="36px"
          width="auto"
        >
          <Tab
            aria-label={name}
            data-testid={isActive ? 'activeTab' : 'tab'}
            id="Tab"
            role="tab"
            onClick={() => setTab(value)}
            {...{ isActive }}
          >
            {name}
          </Tab>
        </Tooltip>
      ) : (
        <Tab
          aria-label={name}
          data-testid={isActive ? 'activeTab' : 'tab'}
          id="Tab"
          role="tab"
          onClick={() => setTab(value)}
          {...{ isActive }}
        >
          {name}
        </Tab>
      );

      return (
        <TabItem id="TabItem" key={name}>
          {tab}
        </TabItem>
      );
    })}
  </TabsCont>
);

export default SectionTabs;
